export const FB_OAUTH_STATE_KEY = 'fb_oauth_state';
export const FB_OAUTH_RETURN_PATH_KEY = 'fb_oauth_return_path';
export const FB_OAUTH_LOCATION_ID_PARAM = 'locationId';
export const FB_OAUTH_STATUS_PARAM = 'fb_status';

export const OAuthCallbackStatus = {
  PROCESSING: 'processing',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type OAuthCallbackStatus = typeof OAuthCallbackStatus[keyof typeof OAuthCallbackStatus];

export const FBOAuthRedirectStatus = {
  CANCELLED: 'cancelled',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type FBOAuthRedirectStatus = typeof FBOAuthRedirectStatus[keyof typeof FBOAuthRedirectStatus];

export const FB_OAUTH_SNACKBAR_MESSAGES: Record<string, { type: 'info' | 'success' | 'error'; message: string }> = {
  [FBOAuthRedirectStatus.CANCELLED]: { type: 'info', message: 'Facebook linking was cancelled.' },
  [FBOAuthRedirectStatus.SUCCESS]: { type: 'success', message: 'Facebook account linked successfully!' },
  [FBOAuthRedirectStatus.ERROR]: { type: 'error', message: 'Failed to link Facebook account. Please try again.' },
};
